import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Output, OnDestroy, OnInit, ElementRef, ViewChild, signal, inject } from '@angular/core';
import { NotificationInAppDto } from '../../common/general-types/notifications.dto';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { NotificationsInAppService } from '../../services/notifications-in-app/notifications-in-app.service';
import { firstValueFrom, take } from 'rxjs';
import { LoadingInlineComponent } from "../loading-inline/loading-inline.component";
import { ImageService } from '../../services/image/image.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { LdgImgComponent } from '../ldg-img/ldg-img.component';

@Component({
  selector: 'atom-notifications-drawer',
  standalone: true,
  imports: [LoadingInlineComponent, DatePipe, LdgImgComponent],
  templateUrl: './notifications-drawer.component.html',
  styleUrl: './notifications-drawer.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NotificationsDrawerComponent implements OnInit, OnDestroy {

  @ViewChild('notificationsDrawerDialog', { static: false }) notificationsDrawerDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('notificationsDrawerButton', { static: false }) notificationsDrawerButton?: ElementRef<HTMLButtonElement>;

  private dialogCloseHandler?: () => void;

  /** All notifications */
  allNotifications = signal<NotificationInAppDto[] | undefined>(undefined);
  displayNotifications = signal<NotificationInAppDto[] | undefined>(undefined);

  /** All or Unread Notifications */
  allOrUnread = signal<'all' | 'unread'>('all');

  /** Services */
  public router = inject(Router);
  public firebaseService = inject(FirebaseService);
  private notificationsInAppService = inject(NotificationsInAppService);
  public imageService = inject(ImageService);
  /** Services - END */

  @Output() close = new EventEmitter<void>();

  ngOnInit(): void {
    console.log('NotificationsDrawerComponent ngOnInit');
    this.getAllNotifications();
  }

  getAllNotifications() {
    if (this.firebaseService.userId) {
      this.notificationsInAppService.getUserNotifications(this.firebaseService.userId).pipe(take(1)).subscribe((notifications) => {
        console.log('👮🏻‍♂️👮🏻‍♂️ Notifications:', notifications);
        this.allNotifications.set(notifications);
        this.displayNotifications.set(JSON.parse(JSON.stringify(notifications)));
      });
    }
  }

  switchToUnread(tab: 'all' | 'unread') {
    this.allOrUnread.set(tab);
    this.displayNotifications.set(undefined);
    if (tab == 'unread' && this.allNotifications) {
      this.displayNotifications.set(this.allNotifications()?.filter(noti => {
        if (noti.read === false) {
          return noti;
        } else {
          return
        }
      }))
    } else {
      this.displayNotifications.set(JSON.parse(JSON.stringify(this.allNotifications())));
    }
  }

  getTabClass(tab: 'all' | 'unread') {
    return this.allOrUnread() === tab 
    ? 'bg-gray-200 text-gray-900 dark:bg-white/10 dark:text-gray-200'
    : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200';
  }

  getReadUnreadClass(read: boolean) {
    if (read === true) {
      return;
    } else {
      return "bg-primary/10 dark:bg-primary/15 rounded-lg ring-1 ring-inset ring-primary/25 dark:ring-primary/30"
    }
  }

  markAllAsRead() {
    if (this.firebaseService.userId) {
    this.notificationsInAppService.markAllAsRead(this.firebaseService.userId).subscribe((res: any) => {
        console.log('👮🏻‍♂️👮🏻‍♂️ Mark All As Read:', res);
        this.allNotifications.set(res);
        this.displayNotifications.set(JSON.parse(JSON.stringify(res)));
      });
    }
  }

  async openNotification(notification: NotificationInAppDto) {
    /** Mark as read */
    try {
      const updatedNotificationRes = await firstValueFrom(this.notificationsInAppService.markAsRead(notification.id));
      this.router.navigate([`/${notification.route}`]);
      this.notificationsInAppService.$unreadNotificationCount.next(0)
      this.closeDrawer();
    } catch (updatedNotificationErr) {
      console.error('updatedNotificationErr: ', updatedNotificationErr);
    }
  }

  closeDrawer() {
    this.notificationsDrawerDialog?.nativeElement?.close();
    this.close.emit();
  }

  ngOnDestroy(): void {
    console.log('NotificationsDrawerComponent ngOnDestroy');
    if (this.dialogCloseHandler) {
      this.dialogCloseHandler();
    }
  }
}
